import _merge from 'lodash.merge';

/**
 * @param data
 * @param baseData
 * @returns {*}
 */
export default function merge(baseData, data) {
  return _merge(baseData, data);
}
